import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// prettier-ignore
const PublicAssetSchema = withDefaults({
  'type': 'public-asset',
  'traits': ['digital-asset'],
  'fields': [
    {
      'kind': 'hasMany',
      'name': 'conditions',
      'type': 'condition',
      'options': {
        'async': false,
        'inverse': 'publicAssets',
      },
    },
  ],
});

export default PublicAssetSchema;
